<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="活动名称：">
            <el-input v-model="query.name" placeholder="请输入活动名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.state" placeholder="请选择" clearable size="small">
              <el-option label="全部" :value="-1"></el-option>
              <el-option label="上架" :value="1"></el-option>
              <el-option label="下架" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间区域：">
            <!-- 时间筛选类型 -1默认全部 1创建时间 2修改时间 3上下架时间 4活动时间" -->
            <el-select v-model="timeType" placeholder="请选择" clearable size="small">
              <el-option label="活动时间" :value="4"></el-option>
              <el-option label="修改时间" :value="2"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-dropdown @command="handleCommand">
            <el-button type="primary" size="mini">批量操作<i class="el-icon--right el-icon-arrow-down"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="beforeHandleCommand(null,2)" v-hasPermi="['goods:seckill:state']">批量下架</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(null,1)" v-hasPermi="['goods:seckill:state']">批量上架</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-button type="primary" size="mini" @click="handleCreate" plain>导出</el-button> -->
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus" v-hasPermi="['goods:seckill:add']">新建活动</el-button>
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column type="selection" width="50" fixed />
        <el-table-column label="活动名称" prop="name" align="center" width="200" fixed>
          <template slot-scope="{row}">
            <el-link type="primary" @click="handleShow(row)">{{row.name}}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="是否在APP展示" prop="isShowApp" align="center">
          <template slot-scope="{row}">
            {{ row.isShowApp===1?'展示':'不展示' }}
            </template>
          </el-table-column>
          <el-table-column label="是否开票" prop="canInvoice" align="center">
            <template slot-scope="{row}">
              {{ row.canInvoice===1?'支持':'不支持' }}
            </template>
          </el-table-column>

        <!-- <el-table-column label="聚水潭编码" prop="name" align="center" width="200" />
        <el-table-column label="商品分类" prop="name" align="center" width="200" /> -->
        <el-table-column label="活动主图" prop="icon" align="center">
          <template slot-scope="{row}">
            <el-image style="width: 50px; height: 50px" :src="row.img" :preview-src-list="[row.img]"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="市场价(元)" prop="retailPrice" align="center" />
        <el-table-column label="活动价(元)" prop="actPrice" align="center" />
        <el-table-column label="活动时间" sortable="custom" align="center">
          <template slot-scope="{row}">
            {{row.listingStartTime}} ~ {{row.listingEndTime}}
          </template>
        </el-table-column>
        <el-table-column label="秒杀份数" prop="salesNum" align="center" />
        <el-table-column label="销量" prop="actualSalesCount" align="center" />
        <el-table-column label="排序" prop="sort" sortable="custom" align="center" />
        <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" width="200" />
        <el-table-column label="状态" prop="isEnable" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.state" :active-value="1" :inactive-value="2" @change="changeSwitch(row)" v-hasPermi="['goods:seckill:state']"></el-switch>
            {{row.state === 1?'启用':'禁用'}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="230" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)" v-hasPermi="['goods:seckill:edit']">编辑</el-button>
            <el-button type="text" @click="handleQRCode(row)" v-hasPermi="['goods:seckill:qrcode']">生成二维码</el-button>
            <el-button type="text" @click="handleLog(row)">日志记录</el-button>
            <!-- <el-button type="text" @click="handleDeleteSingle(row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <goods-add ref="goodsAdd" @created="doQueryList({})" :categorizeOptions="categorizeOptions" />
    <qr-code ref="qrCode" />
  </div>
</template>

<script>
import goodsAdd from './add'
import sysGoodsApi from '@/api/goods/sysGoods'
import Pagination from '@/components/Pagination'
import sysGoodsCategorizeApi from '@/api/goods/sysGoodsCategorize'
import qrCode from "./qrCode.vue"
import { Subtr, accMul } from '@/utils/index'
export default {
  components: {
    Pagination,
    goodsAdd,
    qrCode
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        areaIdList: "1",  //秒杀
        name: undefined,
        state: undefined
      },
      selectItems: [],
      dateTime: [],
      activeName: '1',
      timeType: '',
      categorizeOptions: []  //商品分类
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
    this.getSelectOptions()
  },
  methods: {
    handleFilter() {
      this.dateTime = []
      this.query = { areaIdList: '1' }
      this.timeType = ''
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    getSelectOptions() {
      sysGoodsCategorizeApi.fetchTreeList({ pageNo: 1, pageSize: 1000, parentid: 0 }).then(({ data }) => {
        this.categorizeOptions = this.formatCascaderData(data.list)
      })
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择商品')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      let txt = ""
      if (command.command === 1) {
        this.handleBatchState(ids, 1)
      } else if (command.command === 2) {
        this.handleBatchState(ids, 2)
      }
    },
    handleBatchState(ids, type) {
      let txt = type === 1 ? '确认将选中商品批量上架？' : '确认将选中商品批量下架？'
      this.$common.confirm(txt).then(() => sysGoodsApi.batchState({ goodsId: ids, state: type }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      sysGoodsApi.batchState({ goodsId: [row.id], state: row.state }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    calcQuery() {
      this.query.startTime = undefined
      this.query.endTime = undefined
      if (this.timeType) this.query.selTimeType = this.timeType
      if (this.dateTime.length > 0) {
        this.query.startTime = this.dateTime[0]
        this.query.endTime = this.dateTime[1]
      }
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.calcQuery()
      this.listLoading = true
      return sysGoodsApi.fetchList(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    calcListData(list) {
      if (!list.length) return []
      list.forEach(item => {
        item.retailPrice = item.sysGoodsSpecValuecombineList ? item.sysGoodsSpecValuecombineList[0].retailPrice : 0;
        item.allPrice = 0;
        item.sysGoodsPackageConfigShowList && item.sysGoodsPackageConfigShowList.forEach(itt => {
          if (itt.isGift) {
            item.allPrice = Subtr(item.allPrice, -accMul(itt.num, itt.price))
          }
        })
      });
      return list
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => sysGoodsApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择商品')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => sysGoodsApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },

    /**
     * 打开新建表单
     */
    handleCreate() {
      this.$refs.goodsAdd.handleCreate(this.total)
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$emit('handleShow', row, 2)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.goodsAdd.handleUpdate(row)
    },
    handleQRCode(row) {
      this.$refs.qrCode.handleQRCode(row)
    },
    handleLog(row) {
      this.$router.push("/log/log?type=1&id=" + row.id);
    }
  }
}
</script>
